import React from "react";
import "./PGASweatsGraphDisplay.css";
import {
  BarChart,
  Bar,
  XAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

class CustomizedLabel extends React.Component {
  render() {
    console.log(this.props);

    const { x, y, fill, value, width } = this.props;
    if (value === 0) {
      return null;
    }

    return (
      <text
        x={x + width / 2}
        y={y}
        dy={-4}
        fontSize="16"
        fontFamily="sans-serif"
        fill={fill}
        textAnchor="middle"
      >
        {value}%
      </text>
    );
  }
}

export default function PGASweatsGraphDisplay({ data, width, height }) {
  return (
    <ResponsiveContainer width={width} height={height}>
      <BarChart data={data} margin={{ top: 25 }}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" />
        <Tooltip />
        <Bar dataKey="val" fill="#8884d8" label={<CustomizedLabel />} />
      </BarChart>
    </ResponsiveContainer>
  );
}
